import React, { useState } from 'react';
import Button from '../common/Button';
import ScheduledGameCard from './ScheduledGameCard';
import { SCHEDULED_GAMES_LIST_NOTE } from './scheduledGameCopy';

const ScheduledGamesList = ({
  scheduledGames,
  playersById,
  sessionPlayerStatus,
  courtAssignments,
  waitingList,
  nextAssignments,
  onUpdateOrder,
  onRemove,
  onAdd
}) => {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', e.target.outerHTML);
    e.target.style.opacity = '0.5';
  };

  const handleDragEnd = (e) => {
    e.target.style.opacity = '';
    setDraggedIndex(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    if (draggedIndex !== null && draggedIndex !== dropIndex) {
      onUpdateOrder(draggedIndex, dropIndex);
    }
    setDraggedIndex(null);
  };

  const validateGame = (game) => {
    const playerIds = [
      game.team1_player1_id,
      game.team1_player2_id,
      game.team2_player1_id,
      game.team2_player2_id
    ].filter(Boolean);

    return playerIds.length === 4 && playerIds.every(id => {
      const player = playersById[id];
      const status = sessionPlayerStatus[id];
      return player && (status === 'active' || status === 'signed_up' || status === 'paused');
    });
  };

  const pendingGames = scheduledGames.filter(g => g.status === 'pending' || !g.status);
  const atPendingCap = pendingGames.length >= 5;
  const addActionButtonClass = 'text-xs px-3 py-1 w-full sm:w-auto';

  return (
    <div className="scheduled-games-container">
      <p className="mb-3 text-xs text-text-secondary">{SCHEDULED_GAMES_LIST_NOTE}</p>
      {onAdd && (
        <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <Button
            onClick={onAdd}
            disabled={atPendingCap}
            variant="secondary"
            size="small"
            className={addActionButtonClass}
            title={atPendingCap ? 'Maximum 5 pending scheduled games' : undefined}
          >
            + Add Scheduled Game
          </Button>
        </div>
      )}

      {scheduledGames.length === 0 ? (
        <p className="text-sm text-text-muted">No scheduled games yet.</p>
      ) : (
        <div className="flex gap-4 overflow-x-auto pb-2">
          {scheduledGames.map((game, index) => (
            <div
              key={game.id}
              draggable={!!onUpdateOrder && (game.status === 'pending' || !game.status)}
              onDragStart={(onUpdateOrder && (game.status === 'pending' || !game.status)) ? (e) => handleDragStart(e, index) : undefined}
              onDragEnd={handleDragEnd}
              onDragOver={onUpdateOrder ? handleDragOver : undefined}
              onDrop={onUpdateOrder ? (e) => handleDrop(e, index) : undefined}
              className={`flex-shrink-0 ${draggedIndex === index ? 'opacity-50' : ''}`}
              style={{ minWidth: '300px' }}
            >
              <ScheduledGameCard
                game={game}
                index={index}
                playersById={playersById}
                sessionPlayerStatus={sessionPlayerStatus}
                courtAssignments={courtAssignments}
                waitingList={waitingList}
                nextAssignments={nextAssignments}
                onRemove={onRemove ? () => onRemove(game.id) : undefined}
                isInvalid={!validateGame(game)}
                isDragging={draggedIndex === index}
              />
            </div>
          ))}
        </div>
      )}
      
      {atPendingCap && (
        <p className="text-xs text-text-muted text-center mt-2">
          Maximum 5 pending scheduled games
        </p>
      )}
    </div>
  );
};

export default ScheduledGamesList;
